import React, { useState, forwardRef, useImperativeHandle } from "react";
import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router";
import { resetPassword } from "src/redux/slices/Auth";

import * as Yup from "yup";
import { useFormik, Form, FormikProvider } from "formik";
// material
import { TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Loader from "src/components/loader/Loader";
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

const ResetPasswordForm = forwardRef(({ setSubmitting }, ref) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const LoginSchema = Yup.object().shape({
        email: Yup.string()
            .email(t('ResetPasswordForm.email.invalid'))
            .required(t('FormCommon.required')),
    });

    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: LoginSchema,
        onSubmit: (values, actions) => {
            setLoading(true);
            setSubmitting(true);
            const { email } = values;
            dispatch(resetPassword({ email, t }))
                .unwrap()
                .then(() => {
                    setLoading(false);
                    setSubmitting(false);
                    actions.setSubmitting(false);
                    actions.resetForm();
                    navigate("/dashboard", { replace: true });
                })
                .catch(() => {
                    setLoading(false);
                    setSubmitting(false);
                    actions.setSubmitting(false);
                });
        },
    });

    const {
        errors,
        touched,
        values,
        isSubmitting,
        handleSubmit,
        getFieldProps,
    } = formik;

    useImperativeHandle(ref, () => ({
        submitForm() {
            formik.handleSubmit();
        },
    }));

    return (
        <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                {loading ? (
                    <Loader />
                ) : (
                    <TextField
                        sx={{ mb: 1 }}
                        fullWidth
                        autoComplete="username"
                        type="email"
                        placeholder=""
                        label={t('ResetPasswordForm.email.placeholder')}
                        {...getFieldProps("email")}
                        error={Boolean(touched.email && errors.email)}
                        helperText={touched.email && errors.email}
                    />
                )}
            </Form>
        </FormikProvider>
    );
});

export default ResetPasswordForm;
